function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MaltaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("rect", {
    y: "3",
    width: "24",
    height: "18",
    fill: "#F7FCFF"
  }), /*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2402",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2402)",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "path-3-inside-1_621_2402",
      fill: "white",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 7.5H4.5V9.74441C4.16957 9.82279 3.92376 10.1198 3.92376 10.4742C3.92376 10.4828 3.92391 10.4914 3.9242 10.5H1.5V13.5H3.99807C4.09495 13.7005 4.27845 13.8513 4.5 13.9039V16.5H7.5V13.9135C7.74269 13.8724 7.94571 13.7147 8.04944 13.5H10.5V10.5H8.12331C8.1236 10.4914 8.12374 10.4828 8.12374 10.4742C8.12374 10.103 7.8541 9.79478 7.5 9.73476V7.5Z"
      })
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 7.5H4.5V9.74441C4.16957 9.82279 3.92376 10.1198 3.92376 10.4742C3.92376 10.4828 3.92391 10.4914 3.9242 10.5H1.5V13.5H3.99807C4.09495 13.7005 4.27845 13.8513 4.5 13.9039V16.5H7.5V13.9135C7.74269 13.8724 7.94571 13.7147 8.04944 13.5H10.5V10.5H8.12331C8.1236 10.4914 8.12374 10.4828 8.12374 10.4742C8.12374 10.103 7.8541 9.79478 7.5 9.73476V7.5Z",
      fill: "#A0A0A0"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.5 7.5V7H4V7.5H4.5ZM7.5 7.5H8V7H7.5V7.5ZM4.5 9.74441L4.6154 10.2309L5 10.1397V9.74441H4.5ZM3.9242 10.5V11H4.44141L4.42391 10.4831L3.9242 10.5ZM1.5 10.5V10H1V10.5H1.5ZM1.5 13.5H1V14H1.5V13.5ZM3.99807 13.5L4.44827 13.2825L4.31179 13H3.99807V13.5ZM4.5 13.9039H5V13.5086L4.6154 13.4174L4.5 13.9039ZM4.5 16.5H4V17H4.5V16.5ZM7.5 16.5V17H8V16.5H7.5ZM7.5 13.9135L7.41643 13.4206L7 13.4912V13.9135H7.5ZM8.04944 13.5V13H7.73572L7.59923 13.2825L8.04944 13.5ZM10.5 13.5V14H11V13.5H10.5ZM10.5 10.5H11V10H10.5V10.5ZM8.12331 10.5L7.62359 10.4831L7.60611 11H8.12331V10.5ZM7.5 9.73476H7V10.1571L7.41643 10.2277L7.5 9.73476ZM4.5 8H7.5V7H4.5V8ZM5 9.74441V7.5H4V9.74441H5ZM4.42376 10.4742C4.42376 10.3567 4.50528 10.257 4.6154 10.2309L4.3846 9.25791C3.83387 9.38855 3.42376 9.88286 3.42376 10.4742H4.42376ZM4.42391 10.4831C4.42381 10.4802 4.42376 10.4772 4.42376 10.4742H3.42376C3.42376 10.4885 3.424 10.5027 3.42448 10.5169L4.42391 10.4831ZM1.5 11H3.9242V10H1.5V11ZM2 13.5V10.5H1V13.5H2ZM3.99807 13H1.5V14H3.99807V13ZM4.6154 13.4174C4.5428 13.4002 4.48085 13.3499 4.44827 13.2825L3.54786 13.7175C3.70904 14.0511 4.01411 14.3025 4.3846 14.3904L4.6154 13.4174ZM5 16.5V13.9039H4V16.5H5ZM7.5 16H4.5V17H7.5V16ZM7 13.9135V16.5H8V13.9135H7ZM7.58357 14.4065C7.98957 14.3377 8.32715 14.0745 8.49964 13.7175L7.59923 13.2825C7.56427 13.3548 7.49582 13.4071 7.41643 13.4206L7.58357 14.4065ZM10.5 13H8.04944V14H10.5V13ZM10 10.5V13.5H11V10.5H10ZM8.12331 11H10.5V10H8.12331V11ZM7.62374 10.4742C7.62374 10.4772 7.62369 10.4801 7.62359 10.4831L8.62302 10.5169C8.6235 10.5027 8.62374 10.4885 8.62374 10.4742H7.62374ZM7.41643 10.2277C7.53409 10.2477 7.62374 10.3509 7.62374 10.4742H8.62374C8.62374 9.85503 8.1741 9.3419 7.58357 9.24179L7.41643 10.2277ZM7 7.5V9.73476H8V7.5H7Z",
      fill: "#FECA00",
      mask: "url(#path-3-inside-1_621_2402)"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 3H24V21H12V3Z",
      fill: "#E31D1C"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_2402",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "12",
      y: "3",
      width: "12",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3H24V21H12V3Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask1_621_2402)"
    })]
  })]
}));
//# sourceMappingURL=Malta.js.map